import { ForwardRefExoticComponent, ReactNode } from 'react';
import { Group, GroupColorMap, UserProfile } from 'api';

export interface ITimeline {
  id: UserProfile['id'];
  title: string;
  color_map: Partial<GroupColorMap>;
}

export type UserGroup = Group | ITimeline;

export enum AspectRatios {
  square = 2 / 2,
  wide = 16 / 9,
  none = NaN,
}

export enum PostAction {
  Create = 'Create',
  Edit = 'Edit',
}

export enum PostState {
  View = 'View',
  Edit = 'Edit',
  Customize = 'Customize',
}

export interface IContentLayoutProps {
  selectedGroup?: UserGroup;
}

export type LoaderTypes = 'standard' | 'widget' | 'none' | ReactNode;

// Values are corresponding routes
export enum SuggestionTypes {
  Group = 'group',
  Profile = 'profile',
}

// Values are corresponding routes
export enum SearchResultTypes {
  Group = 'group',
  Profile = 'profile',
  Content = 'content',
}

export interface IFilter {
  component: ForwardRefExoticComponent<any>;
  isSelected: boolean;
  textNode: ReactNode;
}

export interface IClientSettingParams {
  department_id: string;
  location_id: string;
}
